import styled from 'styled-components';
import { CardBody } from 'reactstrap';
import { fontWeight, fontSize, fontFamily } from '@whitelabel/helpers/style/type';
import { gray } from '@whitelabel/helpers/style/colors';
import { spacer, multiply } from '@whitelabel/helpers/style/units';
import { StyledCard } from '@whitelabel/component-library';

export const StyledPDSInsuredCard = styled(StyledCard)`
  margin-bottom: ${spacer};
`;

export const StyledCardBody = styled(CardBody)`
  padding: ${spacer};
`;

export const StyledTitle = styled.p`
  margin-bottom: ${multiply(spacer, 0.5)};
  color: ${gray(600)};
  font-size: ${fontSize('sm')};
  font-family: ${fontFamily('serif')};
  text-transform: uppercase;
`;

export const StyledList = styled.ul`
  margin-bottom: 0;
  padding: 0;
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('base')};
  list-style: none;
`;

export const StyledListItem = styled.li`
  padding: 0;

  &:not(:last-child) {
    margin-bottom: ${multiply(spacer, 0.5)};
  }
`;

export const StyledInsuredAttributes = styled.span`
  color: ${gray(600)};
`;
